import React, { useState } from 'react';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import { HierarchyImportModal } from './HierarchyImportModal';

interface HierarchyImportButtonProps {
  hierarchyType: 'BUSINESS' | 'FUNCTIONAL' | 'GEOGRAPHIC';
  onImport: () => void;
}

export const HierarchyImportButton: React.FC<HierarchyImportButtonProps> = ({
  hierarchyType,
  onImport,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImport = () => {
    onImport();
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="flex items-center bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors"
        title={`Import ${hierarchyType} templates from platform`}
      >
        <DocumentArrowDownIcon className="h-5 w-5 mr-2" />
        Import Platform Templates
      </button>

      <HierarchyImportModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        hierarchyType={hierarchyType}
        onImport={handleImport}
      />
    </>
  );
};
